import { render } from "./CookiesSignIn.vue?vue&type=template&id=c29dcc1a&scoped=true&ts=true&lang=ts"
import script from "./CookiesSignIn.vue?vue&type=script&lang=ts"
export * from "./CookiesSignIn.vue?vue&type=script&lang=ts"

import "./CookiesSignIn.vue?vue&type=style&index=0&id=c29dcc1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29dcc1a"]])

export default __exports__